import React from 'react'
import HomeTyping from '../contents/HomeTyping';

const Home = () => {
  return (
    <div>
      <HomeTyping/>
    </div>
  )
}

export default Home;
